import { render, staticRenderFns } from "./IotModelPointsModal.Style#Drawer.vue?vue&type=template&id=33d7825a&scoped=true&"
import script from "./IotModelPointsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./IotModelPointsModal.Style#Drawer.vue?vue&type=style&index=0&id=33d7825a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d7825a",
  null
  
)

export default component.exports